import React from 'react';
import StocktakeTableRow from './StocktakeTableRow';
import StocktakeTableRowMobile from './StocktakeTableRowMobile';

/**
 * Component for displaying the stocktake table
 * @param {Object} props - Component props
 * @param {Array} props.stocktakes - Array of stocktake objects
 * @param {Boolean} props.loading - Loading state
 * @param {Function} props.openNewStocktakeModal - Function to open the new stock take modal
 * @param {Function} props.navigateToStocktakeDetail - Function to navigate to stocktake detail
 * @param {Boolean} props.isMobile - Whether the view is mobile
 */
const StocktakeTable = ({ stocktakes, loading, openNewStocktakeModal, navigateToStocktakeDetail, isMobile }) => {
  if (loading) {
    return (
      <div className="forms-loading-state">
        <div className="forms-loading-spinner" />
        <p className="forms-loading-text">Loading stock takes...</p>
      </div>
    );
  }

  if (stocktakes.length === 0) {
    return (
      <div className="forms-empty-state">
        <div className="forms-empty-icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
            <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
            <line x1="12" y1="22.08" x2="12" y2="12" />
          </svg>
        </div>
        <h3 className="forms-empty-title">No stock takes yet</h3>
        <p className="forms-empty-text">
          Create a stock take to track your inventory and manage stock levels.
        </p>
        <button className="forms-empty-btn" onClick={openNewStocktakeModal}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          New Stock Take
        </button>
      </div>
    );
  }

  if (isMobile) {
    return (
      <div className="forms-mobile-list">
        {stocktakes.map(stocktake => (
          <StocktakeTableRowMobile
            key={stocktake._id}
            stocktake={stocktake}
            navigateToStocktakeDetail={navigateToStocktakeDetail}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="forms-table-wrapper">
      <table className="forms-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Date</th>
            <th>User</th>
            <th>Last Edit</th>
            <th>Stock Value</th>
            <th>Retail Value</th>
          </tr>
        </thead>
        <tbody>
          {stocktakes.map(stocktake => (
            <StocktakeTableRow
              key={stocktake._id}
              stocktake={stocktake}
              navigateToStocktakeDetail={navigateToStocktakeDetail}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StocktakeTable;
